import * as yup from "yup"
import { Form, Formik } from "formik"
import { ImportAccountNumbersFormContent } from "./ImportAccountNumbersFormContent"
import { ImportAccountNumbersFormValues, UpdateKeyListAccountNumbers } from "../accountNumbersTypes"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { ImportCsvFile } from "../../../../../../shared/components/importCsv/importCsvFileTypes"

type ImportAccountNumbersFormProps = Readonly<{
    onSubmit: (dimensionId: number, importData: ImportCsvFile) => void
}>

export const ImportAccountNumbersForm = ({ onSubmit }: ImportAccountNumbersFormProps) => {
    const { l10n } = useAppLocalization()

    const defaultInitialValues = {
        dimensionId: null,
        updateKey: UpdateKeyListAccountNumbers.ACCOUNT_NUMBER,
        updateMatching: false,
        deleteUnmatched: false,
        file: null,
    }

    const validationSchema = yup.object({
        dimensionId: yup.string().required(l10n.getString("required-field")),
    })

    function handleSubmit({
        file,
        dimensionId,
        updateMatching,
        deleteUnmatched,
        updateKey,
    }: ImportAccountNumbersFormValues) {
        file && dimensionId && onSubmit(dimensionId, { file, updateMatching, deleteUnmatched, updateKey })
    }

    return (
        <>
            <Formik<ImportAccountNumbersFormValues>
                enableReinitialize
                initialValues={defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                <Form>
                    <ImportAccountNumbersFormContent />
                </Form>
            </Formik>
        </>
    )
}
